import React, { useEffect, useRef, useState } from "react";
import { ArcherContainer, ArcherElement } from "react-archer";
import mcommerceVideo from "../../assets/finalCommerce.webm";
import mcommercePoster from "../../assets/commercePoster.avif";
import "../../styles/mCommerceSection.css";

const MCommerceSection = () => {
  const videoRef = useRef(null);
  const [activeSection, setActiveSection] = useState("");
  const [showArrows, setShowArrows] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleTimeUpdate = () => {
      const t = video.currentTime;

      if (t >= 0 && t < 12) {
        setActiveSection("browse-catalog");
      } else if (t >= 12 && t < 20) {
        setActiveSection("add-to-cart");
      } else if (t >= 20 && t < 26) {
        setActiveSection("view-cart");
      } else if (t >= 26) {
        setActiveSection("checkout");
      }
    };

    const handleContextMenu = (e) => e.preventDefault();

    video.addEventListener("timeupdate", handleTimeUpdate);
    video.addEventListener("contextmenu", handleContextMenu);

    const arrowTimer = setTimeout(() => {
      setShowArrows(true);
    }, 100);

    return () => {
      video.removeEventListener("timeupdate", handleTimeUpdate);
      video.removeEventListener("contextmenu", handleContextMenu);
      clearTimeout(arrowTimer);
    };
  }, []);

  return (
    <ArcherContainer strokeColor="#ccc" strokeWidth={2}>
      <div className="mcommerce-flow-container">
        {/* Top Row */}
        <div className="box-row top-row">
          <ArcherElement
            id="browse-catalog"
            relations={[
              {
                targetId: "mcommerce-video",
                sourceAnchor: "bottom",
                targetAnchor: "top",
                className:
                  activeSection === "browse-catalog" && showArrows
                    ? "active-arrow"
                    : "",
                style: {
                  strokeDashoffset:
                    activeSection === "browse-catalog" ? 0 : 400,
                },
              },
            ]}
          >
            <div
              className={`box ${
                activeSection === "browse-catalog" ? "active" : ""
              }`}
            >
              <i className="bx bx-search" />
              Browse Catalog
            </div>
          </ArcherElement>

          <ArcherElement
            id="add-to-cart"
            relations={[
              {
                targetId: "mcommerce-video",
                sourceAnchor: "bottom",
                targetAnchor: "top",
                className:
                  activeSection === "add-to-cart" && showArrows
                    ? "active-arrow"
                    : "",
                style: {
                  strokeDashoffset:
                    activeSection === "add-to-cart" ? 0 : 400,
                },
              },
            ]}
          >
            <div
              className={`box ${
                activeSection === "add-to-cart" ? "active" : ""
              }`}
            >
              <i className="bx bx-cart-add" />
              Add to Cart
            </div>
          </ArcherElement>
        </div>

        {/* Video */}
        <ArcherElement id="mcommerce-video">
          <div
            className={`video-wrapper phone-oriented ${
              activeSection ? "active-border" : ""
            }`}
          >
            <video
              ref={videoRef}
              src={mcommerceVideo}
              autoPlay
              muted
              loop
              preload="metadata"
              poster={mcommercePoster}
              controlsList="nodownload"
              className="video-player"
            />
          </div>
        </ArcherElement>

        {/* Bottom Row */}
        <div className="box-row bottom-row">
          <ArcherElement
            id="view-cart"
            relations={[
              {
                targetId: "mcommerce-video",
                sourceAnchor: "top",
                targetAnchor: "bottom",
                className:
                  activeSection === "view-cart" && showArrows
                    ? "active-arrow"
                    : "",
                style: {
                  strokeDashoffset:
                    activeSection === "view-cart" ? 0 : 400,
                },
              },
            ]}
          >
            <div
              className={`box ${activeSection === "view-cart" ? "active" : ""}`}
            >
              <i className="bx bx-shopping-bag" />
              View Cart
            </div>
          </ArcherElement>

          <ArcherElement
            id="checkout"
            relations={[
              {
                targetId: "mcommerce-video",
                sourceAnchor: "top",
                targetAnchor: "bottom",
                className:
                  activeSection === "checkout" && showArrows
                    ? "active-arrow"
                    : "",
                style: {
                  strokeDashoffset:
                    activeSection === "checkout" ? 0 : 400,
                },
              },
            ]}
          >
            <div
              className={`box ${activeSection === "checkout" ? "active" : ""}`}
            >
              <i className="bx bx-credit-card-alt" />
              Checkout
            </div>
          </ArcherElement>
        </div>
      </div>
    </ArcherContainer>
  );
};

export default MCommerceSection;
